import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[adminDocumentUploadDialogDirective]' })
export class DocumentUploadDialogDirective {
  viewContainerRef = inject(ViewContainerRef);
}
